/* eslint-disable @typescript-eslint/typedef */
import { createSlice } from '@reduxjs/toolkit';

import { RegistrationState, SetProgrammesPayload, SetMemberStatusPayload } from '../../types/state/registration.types';

export const initialState: RegistrationState = {
  programmes: undefined,
  memberStatus: undefined
};

const RegistrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    setProgrammes: (state, action: SetProgrammesPayload): void => {
      state.programmes = action.payload;
    },
    setMemberStatus: (state, action: SetMemberStatusPayload): void => {
      state.memberStatus = action.payload;
    }
  }
});

export const { setProgrammes, setMemberStatus } = RegistrationSlice.actions;

export default RegistrationSlice.reducer;
